import { WorkCorrectCause } from "@project/shared-types";
import { Input } from "../../../components/inputs/Input";
import { RadioButton } from "../../../components/RadioButton/RadioButton";
import { Text } from "../../../components/texts/text";
import { _colorText, _sizeText } from "../../../core/core";
import { InfoCardJob } from "../../job/ui/InfoCardJob/InfoCardJob";




export const CorrectForm = ({
  currentCause,
  setCurrentCause,
  CorrectComment,
  setCorrectComment
}: {
  currentCause: WorkCorrectCause;
  setCurrentCause: (cause: WorkCorrectCause) => void;
  CorrectComment: string;
  setCorrectComment: (comment: string) => void;
}) => {
  return (
    <div className="j-cause-editor">
      <InfoCardJob title="Что нужно исправить?" column>
        <RadioButton
          isActive={currentCause === WorkCorrectCause.EDIT_TEXT}
          onClick={() => {
            setCurrentCause(WorkCorrectCause.EDIT_TEXT);
          }}
        >
          <Text size={_sizeText.m} color={_colorText.black}>
            Исправить текст
          </Text>
        </RadioButton>
        <RadioButton
          isActive={currentCause === WorkCorrectCause.NO_FOTO}
          onClick={() => {
            setCurrentCause(WorkCorrectCause.NO_FOTO);
          }}
        >
          <Text size={_sizeText.m} color={_colorText.black}>
            Добавить фото
          </Text>
        </RadioButton>
        <RadioButton
          isActive={currentCause === WorkCorrectCause.BAD_NAME}
          onClick={() => {
            setCurrentCause(WorkCorrectCause.BAD_NAME);
          }}
        >
          <Text size={_sizeText.m} color={_colorText.black}>
            Исправить имя
          </Text>
        </RadioButton>
      </InfoCardJob>
      <Input
        placeholder="Комментарий*"
        value={CorrectComment}
        setValue={setCorrectComment}
      ></Input>
      <Text size={_sizeText.m} color={_colorText.neutral}>Исполнитель должен будет исправить в течение 24 ч</Text>
    </div>
  )
}